<nav #navigation class="navigation">
  <div class="navigation-bar">
    <div class="navigation-main-bar">
      <div class="container-fluid">
        <div class="row flex-nowrap align-items-center ml-0 mr-0">
          <button
            class="btn btn-icon lg-hide"
            [exception]="navigationElement"
            (appClickOutside)="navOpenClose.emit()"
            (click)="navOpenChange.emit()"
          >
            <span class="icon-hamburger" [inlineSVG]="'/icons/icon-hamburger-no-color.svg'"></span>
          </button>
          <img class="dynamic-logo" *ngIf="logo?.url1x; else defaultLogo" [src]="logo?.url1x" alt="logo" />
          <ng-template #defaultLogo>
            <div class="logo xs-hide" [inlineSVG]="appConfig.logo.dark"></div>
            <div class="logo sm-hide md-hide lg-hide xl-hide" [inlineSVG]="appConfig.logo.mark"></div>
          </ng-template>

          <div #el class="col align-self-center p-0 text-right">
            <button #btnUser class="btn btn-user">
              <a routerLink="/my-questionnaires" class="desktop" routerLinkActive="active">{{
                'global.my_questionnaires' | transloco
              }}</a>
              <div (click)="userMenuOpen = !userMenuOpen" class="user-avatar" [lazyLoad]="me?.photo?.url1x">
                <span class="icon" [inlineSVG]="'/icons/icon-user-blank.svg'" *ngIf="!me?.photo?.url1x"></span>
              </div>
              <button (click)="userMenuOpen = !userMenuOpen" class="menu-btn">
                <span class="icon-triangle" [ngClass]="[userMenuOpen ? 'up' : 'down']"></span>
              </button>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="menu-user"
    [ngClass]="{ open: userMenuOpen }"
    (appClickOutside)="userMenuOpen = false"
    [exception]="btnUser"
  >
    <div class="text-right">
      <div class="menu-panel ml-auto text-left">
        <a routerLink="/my-questionnaires" routerLinkActive="active">
          <button class="btn btn-logout">
            {{ 'global.my_questionnaires' | transloco }}
          </button>
        </a>

        <button class="btn btn-logout" (click)="logout()">
          {{ 'global.logout' | transloco }}
          <span class="chevron-icon" [inlineSVG]="'/icons/icon-chevron-left-no-color.svg'"></span>
        </button>
      </div>
    </div>
  </div>
</nav>
